import { Link } from 'components/common/Link';
import { useDive } from 'hooks/useDive';
import { DiveUserInteractType } from 'hooks/useDive/types/DiveEvents';
import React from 'react';

export const parseLinksAndMentions = (
  text: string,
  allowLinks?: boolean,
  dive?: ReturnType<typeof useDive> | false,
  pageId?: string,
  pageIdBefore?: string,
  allowMention = true
) => {
  const diveUserInteract = (name: string, type: DiveUserInteractType) => {
    if (dive) {
      dive?.trackUserInteract(pageId ?? '', pageIdBefore ?? '', name, type);
    }
  };

  const words = text?.split(/( |\n)/).filter(word => {
    const lineBreak = word.match(/\n/);

    if (lineBreak) {
      return true;
    }
    return word?.trim()?.length > 0;
  });

  if (!words || words?.length === 0) {
    return '';
  }

  return words.map((word, index) => {
    const isLast = words.length - 1 === index;
    const key = `${word}-${index}`;
    let val: string | JSX.Element = isLast ? word : `${word} `;
    const mention = word.match(/(^|\s)@\w+/);
    if (mention && allowMention && mention[0]) {
      const username = mention[0].match(/\w+/)?.[0];
      val = (
        <b key={key}>
          <Link href={`/user/${username}`}>@{username} </Link>
        </b>
      );
    }

    if (allowLinks) {
      const url = word.match(/(https?:\/\/(.+?\.)?([A-Za-z0-9\-._~:/?#[\]@!$&%'()*+,;=]*)?)/i);

      if (url && url.length > 0) {
        val = (
          <b key={key}>
            <Link
              onClick={() => diveUserInteract(url[0], 'external_link')}
              rel="nofollow noreferrer"
              target="_blank"
              href={url[0]}>
              {word}
            </Link>
          </b>
        );
      }

      const internalUrlMatches = word.match(
        /(https?:\/\/(.+?\.)?hiberworld\.com(\/[A-Za-z0-9\-._~:/?#[\]@!$&'()*+,;=]*)?)/i
      );

      if (internalUrlMatches && internalUrlMatches.length > 0) {
        const internalUrl = internalUrlMatches[0];

        const parsedUrl = new URL(internalUrlMatches[0]);
        if (parsedUrl.pathname.startsWith('/play')) {
          // use normal anchor tag to avoid local routing
          val = (
            <b key={key}>
              <a onClick={() => diveUserInteract(internalUrl, 'link')} rel="nofollow" href={internalUrl} target="_self">
                {word}
              </a>
            </b>
          );
        } else {
          val = (
            <b key={key}>
              <Link onClick={() => diveUserInteract(internalUrl, 'link')} rel="nofollow" href={internalUrl}>
                {word}
              </Link>
            </b>
          );
        }
      }
    }

    const lineBreak = word.match(/\n/);

    if (lineBreak && lineBreak.length > 0) {
      val = <br key={key} />;
    }

    return val;
  });
};
